var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<a href=\"#conser/complaint/"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"complaintId") || (depth0 != null ? lookupProperty(depth0,"complaintId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"complaintId","hash":{},"data":data,"loc":{"start":{"line":20,"column":27},"end":{"line":20,"column":42}}}) : helper)))
    + "/new-correspondence\" class=\"btn btn-primary\">Initiate New Correspondence</a>\r\n\r\n<div class=\"correspondence-grid\"></div>";
},"useData":true});